<template>

    <div id="pageHolder">
            <header class="bg-white sticky top-0 z-50">
                <navbar/>
            </header>

            <div id="main" class="" >
                   
                <div id="body_" >
                    <router-view />
                    <!-- <div class="pt-12 px-8 md:px-16 flex flex-col md:flex-row">
                        <img class="" src="/img/doctor.PNG" alt="" style="width:28rem">
                        <div class="md:ml-14 mt-6 md:mt-16" >
                            <img class="w-160" src="/img/herotext.svg" alt="">
                            <img class="mt-4" src="/img/covertext.svg" alt="">
                            <img class="mt-4 mb-8" src="/img/group.svg" alt="" style="width:80%">
                            <router-link to="/CreateAccount"
                            class="py-2 px-14 mt-8 border border-gray-400 bg-red-500 text-white
                                hover:bg-red-600 hover:text-white font-semibold border border-red-500 
                                rounded shadow">Register
                            </router-link>
                                    
                        </div>
                    </div> -->
                </div>
                <!-- End Of Main -->
            </div>
            <footer id="footer">
                <div class="bg-navy">
                    <futahq/>
                </div>
            </footer>
    </div>
</template>


<script>

import Futahq from '../components/Futahq.vue';
import Navbar from '../components/Navbar.vue';
export default {
  components: { Navbar, Futahq },
  name: "Welcome",
};

</script>

<style>

html,body{
    height: 100%;
    color: #04172A;
    font-family: 'DM Sans', sans-serif;
    font-size: 100%;
    
}
@media (max-width: 768px) {
    body {
        font-size: 100%;
    }
}
#pageHolder{
    min-height: 100%;
}

#main{
    overflow: auto;
    padding-bottom: 50px;
}

#footer{
    position: relative;
    height: 50px;
    margin-top: -10px;
    clear: both;
}

</style>